module.exports = __webpack_public_path__ + "img/bannerComodidad.cae93eec.png";